import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
import SearchPaging from "./../factories/search-paging";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import TreeNodeViewModel from "./../factories/tree-node";
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-searcher";
import "./../bindings/bao-tree";
import "./../bindings/bao-number-box";
import AppTabController from "../services/app-tab-controller";
import baoRouter from "../services/bao-router";

function ReminderTicketTemplateViewModel(tabPage) {
    var self = this;
    SearchPaging.call(this, tabPage);

    self.Bao = Bao;
    self.Initialized = ko.observable(false);
    self.IsReadonly = ko.observable(false);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.Name())) {
            isComplete = false;
        }
        if (self.TicketTypeId() == null) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.BeforeDelete = function () {
        Bao.post("ReminderTicketTemplate/IsReminderTicketTemplateInUse", JSON.stringify({
            id: self.OpenData()
        }), function (value) {
            if (value != "true") {
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteTicketTemplate"), "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.Delete();
                    }
                });
            }
            else {
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgIsInUse"), "info");
            }
        });
    };
    self.Save = function () {
        tabPage.IsLoading(true);
        return Bao.post("ReminderTicketTemplate/SaveReminderTicketTemplate", JSON.stringify({
            ticketTemplate: self.MinimizeEntity()
        }), function (value) {
            self.SaveTime(value.Result);
            self.PerformRefresh();
        });
    };
    self.Delete = function () {
        tabPage.IsLoading(true);
        return Bao.post("ReminderTicketTemplate/DeleteReminderTicketTemplate", JSON.stringify({
            ticketTemplate: self.MinimizeEntity()
        }), function (value) {
            tabPage.IsLoading(false);
            AppTabController.RemoveTab(tabPage);
        });
    };
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage.IsActiveTab() == true) {
            switch (value.ActionKey()) {
                case "ReminderTicketTemplateSave":
                    if (self.CompleteCheck() == true) {
                        self.Save();
                    }
                    break;
                case "ReminderTicketTemplateRefresh":
                    self.BeforeRefresh();
                    break;
                case "ReminderTicketTemplateDelete":
                    self.BeforeDelete();
                    break;
                case "ReminderTicketTemplateMoveForwardSearch":
                    self.MoveSearch(self.CurrentSearchIndex() + 1);
                    break;
                case "ReminderTicketTemplateMoveBackwardSearch":
                    self.MoveSearch(self.CurrentSearchIndex() - 1);
                    break;
            }
        }
    }));
    self.DeleteService = function () {
        self.TicketServiceStructureName(null);
        self.TicketServiceStructureId(null);
    };
    self.DeleteGenerationService = function () {
        self.TicketGenerationServiceStructureName(null);
        self.TicketGenerationServiceStructureId(null);
    };
    self.GoToAffectedPerson = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem/Person");
        newTab.UrlData({
            id: self.AffectedPersonId()
        });
        newTab.ObjectId(self.AffectedPersonId());
        AppTabController.AddTab(newTab);
    };
    self.GoToReportingPerson = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem/Person");
        newTab.UrlData({
            id: self.ReportingPersonId()
        });
        newTab.ObjectId(self.ReportingPersonId());
        AppTabController.AddTab(newTab);
    };
    self.GoToAffectedConfigurationItem = function () {
        var newTab = new TabPage();
        newTab.Url("ConfigurationItem");
        newTab.UrlData({
            id: self.AffectedConfigurationItemId()
        });
        newTab.ObjectId(self.AffectedConfigurationItemId());
    };
    self.OpenTreeDialog = function (type, tabtype) {
        this.TabPage.IsLoading(true);
        var ticketTypeCategoryIdFilter;
        if (tabtype == "Reminder") {
            ticketTypeCategoryIdFilter = "12374dc1-884e-4fea-a3bf-0b834b695fdf";
        }
        else {
            ticketTypeCategoryIdFilter = "6414771f-3203-4e7a-a15c-d46185abdba7";
        }
        Bao.post("Ticket/GetTreeDialogDataSource", JSON.stringify({
            type: type,
            ticketTypeCategoryId: ticketTypeCategoryIdFilter
        }), function (value) {
            var dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
            var dialogViewModel: any = {};
            dialogViewModel.NodeToggled = function (node) {
                if (node.Loaded() == false) {
                    this.TabPage.IsLoading(true);
                    var parentId = node.Id();
                    Bao.post("Ticket/GetTreeDialogDataSourceByParent", JSON.stringify({
                        type: type,
                        parentId: parentId,
                        ticketTypeCategoryId: ticketTypeCategoryIdFilter
                    }), function (value) {
                        for (var i = 0; i < value.nodes.length; i++) {
                            node.Nodes.push(new TreeNodeViewModel(value.nodes[i]));
                        }
                        node.Expanded(true);
                        node.Loaded(true);
                        dialog.SetPosition();
                        this.TabPage.IsLoading(false);
                    });
                }
                else {
                    dialog.SetPosition();
                }
            };
            var dataSource = [];
            for (var i = 0; i < value.nodes.length; i++) {
                dataSource.push(new TreeNodeViewModel(value.nodes[i]));
            }
            dialogViewModel.Nodes = ko.observableArray(dataSource);
            dialogViewModel.SelectedService = ko.observable();
            var selectedServiceSubscription = dialogViewModel.SelectedService.subscribe(function () {
                dialogViewModel.okClick();
            });
            dialogViewModel.okClick = function () {
                self.TabPage.IsLoading(true);
                var selectedNode;
                selectedNode = dialogViewModel.SelectedService();
                if (selectedNode != null) {
                    if (selectedNode.IsAllowed()) {
                        return Bao.post("Ticket/GetTicketServiceStructure", JSON.stringify({
                            selectedTicketServiceId: selectedNode.Id()
                        }), function (result) {
                            if (tabtype == "Reminder") {
                                self.InitializeDataBindingTicketServiceStructure(result.TicketServiceStructureId);
                                self.TicketServiceStructureId(result.TicketServiceStructureId);
                                self.OwnerPersonId(result.OwnerUserId);
                                self.OwnerPersonName(result.OwnerUserName);
                                self.OwnerServiceProviderId(result.OwnerRoleId);
                                self.OwnerServiceProviderName(result.OwnerRoleName);
                                dialog.Close();
                                selectedServiceSubscription.dispose();
                                selectedServiceSubscription = null;
                                dialogViewModel.SelectedService(null);
                            }
                            else {
                                self.InitializeDataBindingTicketGenerationServiceStructure(result.TicketServiceStructureId);
                                self.TicketGenerationServiceStructureId(result.TicketServiceStructureId);
                                self.TicketGenerationAffectedPersonId(result.OwnerUserId);
                                self.TicketGenerationAffectedPersonName(result.OwnerUserName);
                                dialog.Close();
                                selectedServiceSubscription.dispose();
                                selectedServiceSubscription = null;
                                dialogViewModel.SelectedService(null);
                            }
                        }).always(_ => self.TabPage.IsLoading(false));
                    }
                }
                this.TabPage.IsLoading(false);
                new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("TicketServiceInvalidSelection"), "info");
                return null;
            };
            dialog.Width(500);
            dialog.ViewModel(dialogViewModel);
            dialog.Template(value.Message);
            dialog.Open();
            dialog.SetPosition();
        })
        .always(_ => this.TabPage.IsLoading(false));
    };
    self.InitializeDataBindingTicketServiceStructure = function (id) {
        Bao.post("Ticket/GetCompleteTicketServiceStructure", JSON.stringify({
            id: id
        }), function (value) {
            self.TicketServiceStructureName(value);
        });
    };
    self.InitializeDataBindingTicketGenerationServiceStructure = function (id) {
        return Bao.post("Ticket/GetCompleteTicketServiceStructure", JSON.stringify({
            id: id
        }), function (value) {
            self.TicketGenerationServiceStructureName(value);
        });
    };
    self.OwnerServiceProviderChanged = function (selectedRow) {
        if (self.OwnerPersonId() != null) {
            Bao.post("Ticket/IsPersonInServiceProvider", JSON.stringify({
                personId: self.OwnerPersonId(),
                serviceProviderId: self.OwnerServiceProviderId()
            }), function (value) {
                if (value != true) {
                    self.OwnerPersonName(null);
                    self.OwnerPersonId(null);
                }
            });
        }
    };
    self.OwnerServiceProviderDeleted = function () {
        self.OwnerPersonDeleted();
    };
    self.OwnerPersonDeleted = function () {
        self.OwnerPersonId(null);
        self.OwnerPersonName(null);
    };
    self.ServiceServiceProviderChanged = function (selectedRow) {
        if (self.ServicePersonId() != null) {
            Bao.post("Ticket/IsPersonInServiceProvider", JSON.stringify({
                personId: self.ServicePersonId(),
                serviceProviderId: self.ServiceServiceProviderId()
            }), function (value) {
                if (value != true) {
                    self.ServicePersonName(null);
                    self.ServicePersonId(null);
                }
            });
        }
    };
    self.ServiceServiceProviderDeleted = function () {
        self.ServicePersonDeleted();
    };
    self.ServicePersonDeleted = function () {
        self.ServicePersonId(null);
        self.ServicePersonName(null);
    };

    self.AfterGetTemplate = function (model) {
        ko.map.fromJS(model, self, self.TabPage.DirtyFlag);
        self.TabPage.SessionTabId = self.SessionTabId();
        if (self.IsNew() || (self.TabPage.ObjectId() != self[self.PrimaryKey]())) {
            self.TabPage.ObjectId(self[self.PrimaryKey]());
        }
        else {
            self.TabPage.ObjectId.valueHasMutated();
        }
    };

    self.init = function () {
        self.TabPage.IsLoading(true);
        return $.when((function () {
            if (tabPage.Object != null && tabPage.Object.ticketModel != null) {
                return Bao.post("ReminderTicketTemplate/GetReminderTicketTemplateByReminderTicket", JSON.stringify({
                    ticketModel: ko.map.toJS(tabPage.Object.ticketModel)
                }));
            }
            else {
                return Bao.post("ReminderTicketTemplate/GetReminderTicketTemplate", JSON.stringify({
                    id: self.TabPage.UrlData().id
                }));
            }
        })()).then(function (model) {
            self.AfterGetTemplate(model);
            self.SearcherTicketType = {
                ObjectId: self.TicketTypeId,
                ObjectValue: "Type",
                SearchType: "TicketType",
                AutoSearch: true,
                AutoComplete: true,
                CustomFilter: {
                    TicketTypeCategoryId: "12374dc1-884e-4fea-a3bf-0b834b695fdf"
                }
            };
            self.NumberBoxReminderInterval = {
                value: self.ReminderIntervall,
                decimalDigits: 0,
                thousandSeperator: false,
                culture: Bao.Session.Language.Symbol()
            };
            self.SearcherTimeUnit = {
                ObjectId: self.TimeUnitId,
                ObjectValue: "Name",
                AutoComplete: true,
                SearchType: "TimeUnit",
                AutoSearch: true,
                Enabled: true
            };
            self.GoToOwnerServiceProvider = function () {
                if (self.OwnerServiceProviderId() != "") {
                    baoRouter.setHash("#serviceprovider/" + self.OwnerServiceProviderId());
                }
            };
            self.GotoOwnerServiceProviderVisible = ko.computed(function () {
                return self.OwnerServiceProviderId() != null && Bao.Session.HasPermission("ServiceProviderSearch", "1A38B671-948C-42EE-B80D-F6B9A12814B6");
            });
            self.SearcherServiceProvider = {
                ObjectId: self.OwnerServiceProviderId,
                ObjectValue: "ServiceProvider",
                SearchType: "ServiceProvider",
                AutoSearch: true,
                AutoComplete: true,
                GotoVisible: self.GotoOwnerServiceProviderVisible,
                Goto: self.GoToOwnerServiceProvider
            };
            self.OwnerPersonSearchEnabled = ko.observable();
            self.OwnerServiceProviderId.subscribe(function (value) {
                if (value == null) {
                    self.OwnerPersonId(null);
                    self.OwnerPersonName("");
                    self.OwnerPersonSearchEnabled(false);
                }
                else {
                    self.OwnerPersonSearchEnabled(true);
                }
            });
            self.GoToOwnerPerson = function () {
                if (self.OwnerPersonId() != "") {
                    baoRouter.setHash("#person/" + self.OwnerPersonId());
                }
            };
            self.GotoOwnerPersonVisible = ko.computed(function () {
                return self.OwnerPersonId() != null && Bao.Session.HasPermission("PersonSearch", "1A38B671-948C-42EE-B80D-F6B9A12814B6");
            });
            self.SearcherOwnerPerson = {
                ObjectId: self.OwnerPersonId,
                ObjectValue: "FullName",
                SearchType: "Person",
                CustomFilter: {
                    ServiceProviderId: self.OwnerServiceProviderId
                },
                Enabled: self.OwnerPersonSearchEnabled,
                AutoSearch: true,
                AutoComplete: true,
                GotoVisible: self.GotoOwnerPersonVisible,
                Goto: self.GoToOwnerPerson
            };
            self.GoToContract = function () {
                if (self.ContractId() != "") {
                    baoRouter.setHash("#contract/" + self.ContractId());
                }
            };
            self.GotoContractVisible = ko.computed(function () {
                return self.ContractId() != null && Bao.Session.HasPermission("ContractSearch", "1A38B671-948C-42EE-B80D-F6B9A12814B6");
            });
            self.SearcherContract = {
                ObjectId: self.ContractId,
                ObjectValue: "Name1",
                AutoComplete: true,
                AutoSearch: true,
                SearchType: "Contract",
                GotoVisible: self.GotoContractVisible,
                Goto: self.GoToContract
            };
            self.NumberBoxCheckwareTaskForerun = {
                value: self.CheckwareTaskForerun,
                decimalDigits: 0,
                thousandSeperator: false,
                culture: Bao.Session.Language.Symbol()
            };
            self.SearcherFolderStructureChecklist = {
                ObjectId: self.FolderStructureChecklistId,
                ObjectValue: "ListName",
                SearchType: "Checkware-FolderStructureChecklist",
                AutoComplete: true,
                AutoSearch: true
            };
            self.SearcherTicketGenerationType = {
                ObjectId: self.TicketGenerationTypeId,
                ObjectValue: "Type",
                AutoComplete: true,
                SearchType: "TicketType",
                AutoSearch: true,
                CustomFilter: {
                    TicketTypeCategoryId: "6414771f-3203-4e7a-a15c-d46185abdba7"
                }
            };
            self.SearcherTicketGenerationPriority = {
                ObjectId: self.TicketGenerationPriorityId,
                ObjectValue: "Priority",
                AutoComplete: true,
                SearchType: "TicketPriority",
                AutoSearch: true
            };
            self.SearcherTicketGenerationAffectedPerson = {
                ObjectId: self.TicketGenerationAffectedPersonId,
                ObjectValue: "FullName",
                SearchType: "Person",
                AutoComplete: true,
                AutoSearch: true,
                Enabled: self.TicketGenerationTemplateDependsOnPerson
            };
            self.ChooseAPerson.subscribe(function (value) {
                if (value === "0") {
                    self.TicketGenerationAffectedPersonId(null);
                    self.TicketGenerationAffectedPersonName(null);
                    self.TicketGenerationTemplateDependsOnPerson(false);
                }
                else {
                    self.TicketGenerationTemplateDependsOnPerson(true);
                }
            });
        });
    };
}
;
Bao.inherit(ReminderTicketTemplateViewModel, SearchPaging);
ReminderTicketTemplateViewModel.prototype.PrimaryKey = "TicketTemplateId";
ReminderTicketTemplateViewModel.prototype.RefreshUrl = "ReminderTicketTemplate/GetReminderTicketTemplate";
ReminderTicketTemplateViewModel.prototype.PermissionForward = "ReminderTicketTemplateMoveForwardSearch";
ReminderTicketTemplateViewModel.prototype.PermissionBackward = "ReminderTicketTemplateMoveBackwardSearch";
export default ReminderTicketTemplateViewModel;